/**
 * Editorial slow marquee. One line, giant serif, oversized dot separators.
 * Duplicates children so the tape reads seamlessly.
 */
export default function Marquee({ items = [], speed = 60, dataTestId }) {
    const line = items.length ? items : ["Members Only", "Stockholm", "Since MMXXV", "Kungsträdgården"];
    // duplicate 3x for long, always-full tape
    const tape = [...line, ...line, ...line];

    return (
        <div
            className="marquee-viewport"
            data-testid={dataTestId}
            aria-label={line.join(" — ")}
        >
            <div className="marquee-track" style={{ animationDuration: `${speed}s` }}>
                {tape.map((word, i) => (
                    <span key={i} className="marquee-item">
                        <span className="marquee-word">{word}</span>
                        <span className="marquee-dot" aria-hidden="true">✦</span>
                    </span>
                ))}
            </div>
        </div>
    );
}
